"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateOnboardingUrl = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _icon = require("@site/pattern-library-utils/icon");
const OverlayContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "OverlayContainer",
  class: "pl-oya2tch"
});
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonContainer",
  class: "pl-b92i59i"
});
const TabButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "TabButton",
  class: "pl-t16f7avy"
});

/**
 * Generates the onboarding URL by replacing placeholders with actual values
 *
 * @param {string} onboardingUrl The original onboarding URL with placeholders
 * @param {string} lid The lid value to replace the '{lid}' placeholder
 * @param {string} vertical The vertical value to replace the '{vertical}' placeholder
 * @param {string} templateId The template ID value to replace the '{templateId}' placeholder
 * @returns {string} The generated onboarding URL with replaced placeholders
 */
const generateOnboardingUrl = (onboardingUrl, lid, vertical, templateId) => {
  if (typeof window !== 'undefined') {
    let url = onboardingUrl;
    const hasLidPlaceholder = url.includes('{lid}');
    const hasVerticalPlaceholder = url.includes('{vertical}');
    const hasTemplateIdPlaceholder = url.includes('{templateId}');
    if (hasLidPlaceholder) {
      url = url.replace('{lid}', lid);
    }
    if (hasVerticalPlaceholder) {
      url = url.replace('{vertical}', vertical);
    }
    if (hasTemplateIdPlaceholder) {
      url = url.replace('{templateId}', templateId);
    }
    return url;
  }
  return onboardingUrl;
};

/**
 * Overlay Component.
 *
 * @param {Object} props React props
 * @param {String} props.primarySize Primary Cta Size
 * @param {String} props.primaryCtaText Primary Cta Text
 * @param {String} props.primaryCtaAriaLabel Primary Cta Aria Label
 * @param {String} props.onboardingUrl Primary Cta Url
 * @param {String} props.secondaryCtaText Secondary Cta Text
 * @param {String} props.secondaryCtaAriaLabel Secondary Cta Aria Label
 * @param {Function} props.modalFn React props
 * @returns {React.ReactElement} Overlay Component
 * @public
 */
exports.generateOnboardingUrl = generateOnboardingUrl;
function Overlay({
  primarySize = 'default',
  primaryCtaText = 'Start Editing',
  primaryCtaAriaLabel = 'Template Name Aria Label',
  lid,
  vertical,
  onboardingUrl = 'https://onboarding.godaddy.com/launch',
  secondaryCtaText = 'Preview',
  secondaryCtaAriaLabel = 'Preview the template',
  modalFn,
  templateId
}) {
  const onBoardUrl = generateOnboardingUrl(onboardingUrl, lid, vertical, templateId);
  return /*#__PURE__*/_react.default.createElement(OverlayContainer, {
    className: "overlay",
    "data-cy": "card-overlay"
  }, /*#__PURE__*/_react.default.createElement(ButtonContainer, null, primaryCtaText && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    text: primaryCtaText,
    design: "primary",
    shrinkOn: "mobile",
    size: primarySize,
    href: onBoardUrl,
    inverted: true,
    ariaLabel: primaryCtaAriaLabel
  }), secondaryCtaText && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    onClick: modalFn,
    text: secondaryCtaText,
    design: "inline",
    size: "small",
    inverted: true,
    ariaLabel: secondaryCtaAriaLabel
  })), /*#__PURE__*/_react.default.createElement(TabButton, {
    onClick: modalFn,
    ariaLabel: secondaryCtaAriaLabel
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "show"
  })));
}
var _default = exports.default = Overlay;
Overlay.propTypes = {
  primarySize: _propTypes.default.string,
  primaryCtaText: _propTypes.default.string,
  primaryCtaAriaLabel: _propTypes.default.string,
  lid: _propTypes.default.string,
  vertical: _propTypes.default.string,
  onboardingUrl: _propTypes.default.string,
  secondaryCtaText: _propTypes.default.string,
  secondaryCtaAriaLabel: _propTypes.default.string,
  modalFn: _propTypes.default.func,
  templateId: _propTypes.default.string
};